module.exports = __webpack_public_path__ + "static/media/menuHours.02d26a2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuHours.svg
// module id = 473
// module chunks = 0